import apiRoutes from '../../../config/apiRoutes';

const convertTracks = (list) => {
  return list.map((item) => {
    return { ...item, track: apiRoutes.AUDIO_BOOK_LISTEN(item.id) };
  });
};

export default convertTracks;
